'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.getInterpolator = getInterpolator;

exports.default = function (nameSpace, attr, value) {
  return getTween.call(this, nameSpace, attr, getInterpolator(attr, value), value);
};

var _d3Interpolate = require('d3-interpolate');

var _d3Color = require('d3-color');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//  weak

function getTween(nameSpace, attr, interpol, value1) {
  return function tween() {
    var _this = this;

    var value0 = nameSpace ? this.state[nameSpace][attr] : this.state[attr];

    if (value0 === value1) {
      return null;
    }

    var i = interpol(value0, value1);

    var stateTween = void 0;

    if (nameSpace === null) {
      stateTween = function stateTween(t) {
        _this.setState(function () {
          return (0, _defineProperty3.default)({}, attr, i(t));
        });
      };
    } else {
      stateTween = function stateTween(t) {
        _this.setState(function (state) {
          return (0, _defineProperty3.default)({}, nameSpace, (0, _extends4.default)({}, state[nameSpace], (0, _defineProperty3.default)({}, attr, i(t))));
        });
      };
    }

    return stateTween;
  };
}

function getInterpolator(attr, value) {
  if (attr === 'transform') {
    return _d3Interpolate.interpolateTransformSvg;
  } else if (typeof value === 'number') {
    return _d3Interpolate.interpolateNumber;
  } else if (value instanceof _d3Color.color || (0, _d3Color.color)(value) !== null) {
    return _d3Interpolate.interpolateRgb;
  }

  return _d3Interpolate.interpolateString;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/resonance/core/transition/tween.js
// module id = XgpI
// module chunks = 0